import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";
import { TaskNotificationType } from "../commonTypes";

type TaskQueueState = CommonTableState & {
    tasks: Array<TaskNotificationType>;
};

const initialState: TaskQueueState = {
    tasks: [],
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            description: false,
            creator: false,
            created: true,
            cronExpression: false,
            repeatTime: false,
        },
        columnOrder: [
            "mrt-row-select",
            "type",
            "status",
            "started",
            "ended",
            "created",
            "nextTryAfter",
            "unsuccessfulAttempts",
            "targetId",
            "targetType",
            "exitMessage",
            "creator",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const taskQueueSlice = createSlice({
    name: "taskQueue",
    initialState: initialState,
    reducers: {
        updateTaskTableState: (state, action) => updateTableState(state, action, initialState.tableState),
        createUpdateTask: (state, action: PayloadAction<TaskNotificationType>) => {
            const filteredTasks = state.tasks.filter((t) => t.taskId !== action.payload.taskId);
            state.tasks = [...filteredTasks, action.payload];
        },
    },
});

// Action creators are generated for each case reducer function
export const {updateTaskTableState, createUpdateTask} = taskQueueSlice.actions;

export default taskQueueSlice.reducer;
